/* Carte d'accueil (InteractiveMap.tsx) : une punaise par ville, regroupées (markercluster).
   Source : tag produit « geo:<lat>|<lng> » dans window.jpProduits (regions.js). Produits de même coordonnées = même ville ; les encadrés (type:encadre) sont ignorés.
   Page dédiée /pages/carte. Une affiche : clic = fiche ; plusieurs : clic = galerie de vignettes. Rien à maintenir à la main pour les nouvelles villes. */
(async () => {
  const section = document.querySelector('[data-map]');
  if (!section || !window.L) return;
  const boite = section.querySelector('[data-map-box]');
  const L = window.L;
  const villes = new Map();
  try {
    for (const p of await window.jpProduits) {
      if (p.tags.includes('type:encadre')) continue; // une entrée par affiche : le nu ; l'encadré est son jumeau (custom.jumeau)
      const [lat, lng] = (p.tags.find((t) => /^geo:-?\d+(\.\d+)?\|-?\d+(\.\d+)?$/.test(t)) || '').slice(4).split('|').map(Number);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
      const cle = `${lat}|${lng}`;
      if (!villes.has(cle)) villes.set(cle, { lat, lng, produits: [] });
      villes.get(cle).produits.push(p);
    }
  } catch (e) { boite.hidden = true; return; }
  if (!villes.size) { boite.hidden = true; return; } // aucun produit géolocalisé : pas de carte vide
  const d = section.dataset;
  const nom = (p) => p.title.replace(/^Affiche /, '');
  const ville = (p) => nom(p).split(' — ')[0];
  const vignette = (p) => { const u = p.images[0] && new URL(p.images[0].src); if (u) u.searchParams.set('width', 160); return u ? u.href : ''; };
  const nbAffiches = [...villes.values()].reduce((s, v) => s + v.produits.length, 0);
  section.querySelector('[data-map-count]').textContent = d.count.replace('[villes]', villes.size).replace('[affiches]', nbAffiches);

  const map = L.map(section.querySelector('[data-map-canvas]'), { center: [46.6, 2.4], zoom: 5, scrollWheelZoom: false, dragging: !L.Browser.mobile, worldCopyJump: true });
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>', maxZoom: 18 }).addTo(map);
  const couche = L.markerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 45, spiderfyOnMaxZoom: true }).addTo(map);
  const pin = '<svg width="28" height="36" viewBox="0 0 28 36" xmlns="http://www.w3.org/2000/svg"><path d="M14 1C7.4 1 2 6.3 2 12.9 2 21.6 14 35 14 35s12-13.4 12-22.1C26 6.3 20.6 1 14 1z" fill="#c2410c" stroke="#FDFCF8" stroke-width="2"/><circle cx="14" cy="13" r="4.6" fill="#FDFCF8"/></svg>';
  const pastille = (n) => `<span style="position:absolute;top:-4px;right:-6px;min-width:17px;height:17px;padding:0 4px;border-radius:9px;background:#1A1A1A;color:#FDFCF8;border:1.5px solid #FDFCF8;font:700 10px/14px ui-monospace,monospace;text-align:center;box-sizing:border-box;">${n}</span>`;

  const galerie = (nomVille, produits) => {
    const racine = document.createElement('div');
    racine.className = 'poster-gallery';
    racine.innerHTML = '<div class="poster-gallery__title"></div><div class="poster-gallery__sub"></div><div class="poster-gallery__grid"></div>';
    racine.firstChild.textContent = nomVille;
    racine.children[1].textContent = d.views.replace('[n]', produits.length);
    for (const p of produits) {
      const a = document.createElement('a');
      a.href = `/products/${p.handle}`;
      a.title = nom(p);
      const img = document.createElement('img');
      img.src = vignette(p);
      img.alt = nom(p);
      img.loading = 'lazy';
      a.append(img);
      racine.children[2].append(a);
    }
    L.DomEvent.disableClickPropagation(racine);
    L.DomEvent.disableScrollPropagation(racine);
    return racine;
  };

  villes.forEach(({ lat, lng, produits }) => {
    const nomVille = ville(produits[0]);
    const icon = L.divIcon({ className: 'poster-pin', html: produits.length > 1 ? pin + pastille(produits.length) : pin, iconSize: [28, 36], iconAnchor: [14, 36], popupAnchor: [0, -34], tooltipAnchor: [0, -32] });
    const marker = L.marker([lat, lng], { icon, alt: nomVille });
    marker.bindTooltip(produits.length > 1 ? d.multi.replace('[ville]', nomVille).replace('[n]', produits.length) : nom(produits[0]), { direction: 'top' });
    if (produits.length === 1) marker.on('click', () => { location.href = `/products/${produits[0].handle}`; });
    else marker.bindPopup(() => galerie(nomVille, produits), { className: 'poster-gallery-popup', minWidth: 240, maxWidth: 260, closeButton: true });
    marker.addTo(couche);
  });
  // Cadrage sur TOUTES les punaises (réglages d'InteractiveMap : marge 48, maxZoom 6 pour une ville, 9 sinon) ; refait à chaque redimensionnement.
  const points = [...villes.values()].map((v) => [v.lat, v.lng]);
  const cadrer = () => { map.invalidateSize(); map.fitBounds(points, { padding: [48, 48], maxZoom: points.length > 1 ? 9 : 6 }); };
  setTimeout(cadrer, 0);
  if (window.ResizeObserver) new ResizeObserver(cadrer).observe(section.querySelector('[data-map-canvas]'));
})();
